<template>
  <div>
    <resource-languages resource_type="Position" :resource_id="payload.position_id" :resource_data="payload.position_data" :languages="languages"></resource-languages>
  </div>
</template>
<script>
import ResourceLanguages from '@/components/ResourceLanguages'
export default {
  name: 'position-languages',
  props: ['payload'],
  data () {
    return {
      languages: []
    }
  },
  created () {
    this.$network_utils.getPositionLanguages({ position_id: this.payload.position_id, current_company_id: this.payload.company_id }).then(response => {
      this.languages = response
    })
  },
  components: {
    ResourceLanguages
  }
}
</script>
